import { isNullOrEmpty } from "../../../../../../../../Common/TypingUtils";
import { FiasApi } from "../../FiasApi";

import { getHouseTypeLongName, getHouseTypeObjectID, getHouseTypeShortName } from "./House/House";
import { getRoomTypeLongName, getRoomTypeShortName } from "./Room/Room";
import { getFlatTypeLongName, getFlatTypeObjectID, getFlatTypeShortName } from "./Flat/Flat";
import { fiasConvertationMethods, fiasConvertationToShowMethods } from "./Types";
import {
    getMunicipalDistrictTypeCode,
    getMunicipalDistrictTypeCodeWithFT,
    getMunicipalDistrictTypeShortName,
} from "./MunicipalDistrict/MunicipalDistrict";
import { extractRegionCode, getRegionNameByCode } from "./Region/Region";
import { getUrbanSettlementTypeCode, getUrbanSettlementTypeShortName } from "./UrbanSettlement/UrbanSettlement";
import { convertAbbreviationToFullName, convertAbbreviationToShortName } from "./Others/UrbanSettlement";
import { extractOKTMO8Symbols } from "./OKTMO/OKTMO";

export function acceptHelperConvertationToValue(value: string, helper?: fiasConvertationMethods) {
    if (isNullOrEmpty(helper)) {
        return value;
    }
    switch (helper) {
        case fiasConvertationMethods.getHouseTypeShortName:
            return getHouseTypeShortName(value);
        case fiasConvertationMethods.getHouseTypeLongName:
            return getHouseTypeLongName(value);
        case fiasConvertationMethods.getHouseTypeObjectID:
            return getHouseTypeObjectID(value);
        case fiasConvertationMethods.getFlatTypeShortName:
            return getFlatTypeShortName(value);
        case fiasConvertationMethods.getFlatTypeLongName:
            return getFlatTypeLongName(value);
        case fiasConvertationMethods.getFlatTypeObjectID:
            return getFlatTypeObjectID(value);
        case fiasConvertationMethods.getRoomTypeLongName:
            return getRoomTypeLongName(value);
        case fiasConvertationMethods.getRoomTypeShortName:
            return getRoomTypeShortName(value);
        case fiasConvertationMethods.getMunicipalDistrictTypeCodeWithFT:
            return getMunicipalDistrictTypeCodeWithFT(value);
        case fiasConvertationMethods.getMunicipalDistrictTypeCode:
            return getMunicipalDistrictTypeCode(value);
        case fiasConvertationMethods.getMunicipalDistrictTypeShortName:
            return getMunicipalDistrictTypeShortName(value);
        case fiasConvertationMethods.extractRegionCode:
            return extractRegionCode(value);
        case fiasConvertationMethods.extractOKTMO8Symbols:
            return extractOKTMO8Symbols(value);
        case fiasConvertationMethods.getUrbanSettlementTypeCode:
            return getUrbanSettlementTypeCode(value);
        case fiasConvertationMethods.getUrbanSettlementTypeShortName:
            return getUrbanSettlementTypeShortName(value);
        case fiasConvertationMethods.convertAbbreviationToFullName:
            return convertAbbreviationToFullName(value);
        case fiasConvertationMethods.convertAbbreviationToShortName:
            return convertAbbreviationToShortName(value);
        default:
            return "";
    }
}

export async function acceptHelperConvertationToShow(
    value: string,
    helper: fiasConvertationToShowMethods | undefined,
    apiClient: FiasApi
) {
    if (isNullOrEmpty(helper)) {
        return value;
    }
    switch (helper) {
        case fiasConvertationToShowMethods.getRegionNameByCode:
            return await getRegionNameByCode(value, apiClient);
        case fiasConvertationToShowMethods.getMunicipalDistrictTypeShortName:
            return getMunicipalDistrictTypeShortName(value);
        case fiasConvertationToShowMethods.getUrbanSettlementTypeShortName:
            return getUrbanSettlementTypeShortName(value);
        default:
            return "";
    }
}
